import { render } from "./AiProcessTaskStatusComponent.vue?vue&type=template&id=5010f161"
import script from "./AiProcessTaskStatusComponent.vue?vue&type=script&lang=js"
export * from "./AiProcessTaskStatusComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__